<div #stickyElement [class]="!showAsBar && sticky ? 'bottom-full-layer-sticky bottom-full-layer' : 'bottom-full-layer'" *ngIf="!showAsBar">
    <div class="offer-container">
        <a [routerLink]="link" class="btn btn-primary btn-lg btn-block btn-offer">
            <div class="offer-txt-promo-text" [innerHTML]="description + '<br>' + additionalDescription"></div>
            <div class="offer-txt-get-offer-text">
                &nbsp;&nbsp;&nbsp;Get Offer
                <img src="assets/images/arrow-right.svg" alt="arrow" class="arrow-icon">
            </div>
            
        </a>
    </div>
</div>

<div class="offer-bar" *ngIf="showAsBar">
    <a [routerLink]="link">
        <div [innerHTML]="description"></div>
        <div  [innerHTML]="additionalDescription"></div>
        <div>
            &nbsp;&nbsp;&nbsp;Get Offer
            <img src="assets/images/arrow-right.svg" alt="arrow" class="arrow-icon">
        </div>
    </a>
</div>
